export var Api_ShareLink_Feed_Type;
(function (Api_ShareLink_Feed_Type) {
    Api_ShareLink_Feed_Type["DISCOVER"] = "discover";
    Api_ShareLink_Feed_Type["SINGLE_VIDEO"] = "single_video";
    Api_ShareLink_Feed_Type["CHANNEL_TIMELINE"] = "channel_timeline";
    Api_ShareLink_Feed_Type["CHANNEL_CONTEXTUAL"] = "channel_contextual";
    Api_ShareLink_Feed_Type["CHANNEL_PERSONALIZED"] = "channel_personalized";
    Api_ShareLink_Feed_Type["PLAYLIST"] = "playlist";
    Api_ShareLink_Feed_Type["HASHTAG_POPULAR"] = "hashtag_popular";
})(Api_ShareLink_Feed_Type || (Api_ShareLink_Feed_Type = {}));
export var Api_Sharelink_Param_Type;
(function (Api_Sharelink_Param_Type) {
    Api_Sharelink_Param_Type["FRAGMENT"] = "fragment";
    Api_Sharelink_Param_Type["QUERY"] = "query";
})(Api_Sharelink_Param_Type || (Api_Sharelink_Param_Type = {}));
